import { axiosService } from "./axiosService";

const imageApi = {
    uploadImage(body) {
        const url = '/image';
        return axiosService.post(url, body)
    },
    deleteImage(id) {
        const url = `/image/${id}`;
        return axiosService.delete(url)
    },
}

export default imageApi;